// actionTypes.js
export const GET_HOLIDAYS = "GET_HOLIDAYS"
export const GET_HOLIDAYS_SUCCESS = "GET_HOLIDAYS_SUCCESS"
export const GET_HOLIDAYS_FAIL = "GET_HOLIDAYS_FAIL"

export const ADD_HOLIDAY = "ADD_HOLIDAY"
export const ADD_HOLIDAY_SUCCESS = "ADD_HOLIDAY_SUCCESS"
export const ADD_HOLIDAY_FAIL = "ADD_HOLIDAY_FAIL"

export const UPDATE_HOLIDAY = "UPDATE_HOLIDAY"
export const UPDATE_HOLIDAY_SUCCESS = "UPDATE_HOLIDAY_SUCCESS"
export const UPDATE_HOLIDAY_FAIL = "UPDATE_HOLIDAY_FAIL"

export const DELETE_HOLIDAY = "DELETE_HOLIDAY"
export const DELETE_HOLIDAY_SUCCESS = "DELETE_HOLIDAY_SUCCESS"
export const DELETE_HOLIDAY_FAIL = "DELETE_HOLIDAY_FAIL"

export const SET_HOLIDAY_FIELD_ERRORS = "SET_HOLIDAY_FIELD_ERRORS"